// --- 反馈管理 --- //

export default [
  {
    name: "legalServiceList",
    path: "/supplySystem/:supplyId/legalManagement/legalServiceList",
    meta: { title: "栏目与内容" },
    component: require("business/platformManagement/legalManagement/list.vue").default
  },
  {
    name: "legalServiceCount",
    path: "/supplySystem/:supplyId/legalManagement/legalServiceCount",
    meta: { title: "浏览统计" },
    component: require("business/platformManagement/legalManagement/count.vue").default
  }
];
